<template>
  <div class="RoutePointSet">
    <div class="header aw">
      <app-space class="label-div">
        <div class="ah"><div class="block"></div></div>
        <label class="label">基本信息</label>
      </app-space>
      <el-form
        ref="form"
        :hide-required-asterisk="true"
        :model="model"
        :rules="rules"
      >
        <el-form-item prop="name">
          <template #label>
            <span class="c999999 font-size-12">路径名称</span>
          </template>
          <el-input
            class="font-size-12 error-top-0"
            v-model.trim="model.name"
            clearable
            :maxlength="20"
            show-word-limit
            placeholder="请输入路径名称"
            @focus="focus()"
            @input="onChange"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <template #label>
            <span class="c999999 font-size-12">通行方式</span>
          </template>
          <el-select
            class="font-size-12 no-body"
            :popper-append-to-body="false"
            v-model="model.way"
            @focus="focus()"
            @input="onChange"
          >
            <el-option label="无人机" value="DRONE"></el-option>
            <el-option label="驾车" value="DRIVING"></el-option>
            <el-option label="步行" value="WALKING"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="header aw">
      <app-space class="label-div">
        <div class="block"></div>
        <label class="label">途径点位</label>
      </app-space>
      <el-form class="maxheight500" label-width="auto" label-position="left">
        <el-form-item class="line-height-40 no-margin-bottom">
          <template #label>
            <span class="cdddddd font-size-12">{{
              calcPointName(model.start)
            }}</span>
          </template>
          <app-space size="zero">
            <el-input
              class="flex font-size-12"
              v-model="model.start.markName"
              readonly
              placeholder="请选择途径点"
              :class="{ focus: model.start && model.start.selected }"
              @click.native="focus(model.start)"
            ></el-input>
            <Icon
              content="添加途径点"
              name="icon-plus"
              type="big"
              @click="addRoutePoint"
            ></Icon>
          </app-space>
        </el-form-item>
        <draggable @sort="onChange" v-model="model.others">
          <transition-group>
            <el-form-item
              class="line-height-40 no-margin-bottom"
              v-for="item in model.others"
              :key="item.id"
            >
              <template #label>
                <span class="cdddddd font-size-12">{{
                  calcPointName(item)
                }}</span>
              </template>
              <app-space size="zero">
                <el-input
                  class="flex font-size-12"
                  v-model="item.markName"
                  readonly
                  placeholder="请选择途径点"
                  :class="{ focus: item && item.selected }"
                  @click.native="focus(item)"
                ></el-input>
                <Icon
                  content="删除途径点"
                  name="icon-reduce"
                  type="big"
                  @click="delRoutePoint(item)"
                ></Icon>
              </app-space>
            </el-form-item>
          </transition-group>
        </draggable>
        <el-form-item
          class="line-height-40 no-margin-bottom"
          :label="calcPointName(model.end)"
        >
          <template #label>
            <span class="cdddddd font-size-12">{{
              calcPointName(model.end)
            }}</span>
          </template>
          <app-space size="zero">
            <el-input
              class="flex font-size-12"
              v-model="model.end.markName"
              readonly
              placeholder="请选择途径点"
              :class="{ focus: model.end && model.end.selected }"
              @click.native="focus(model.end)"
            ></el-input>
            <div class="placeholder"></div>
          </app-space>
        </el-form-item>
      </el-form>
    </div>
    <el-divider class="divider"></el-divider>
  </div>
</template>

<script>
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import * as api from '@/api/route'
import AppSpace from '@/components/app-space.vue'
import Draggable from 'vuedraggable'
import { validateContacts } from '@/utils/rules.js'
export default {
  components: { AppSpace, Draggable },
  props: {
    /**
     * 规划路径基本信息
     */
    info: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      model: {
        // 路径名称
        name: '',
        // 通行方式：DRONE代表无人机、DRIVING代表驾车、WALKING代表步行
        way: 'DRONE',
        // 途经点（起点）
        start: {
          id: _.uniqueId('temp_'),
          markName: '',
          type: 'ORIGIN',
          selected: false
        },
        // 途经点（终点）
        end: {
          id: _.uniqueId('temp_'),
          markName: '',
          type: 'DESTINATION',
          selected: false
        },
        // 其他途经点
        others: []
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'change' },
          { min: 1, max: 20, message: '请输入1~20个字符', trigger: 'change' },
          { validator: validateContacts, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    others () {
      return [this.model.start, ...this.model.others, this.model.end]
    }
  },
  methods: {
    onChange () {
      this.$emit('change')
    },
    calcPointName (item) {
      let name
      switch (item.type) {
        case 'ORIGIN':
          name = '起点'
          break
        case 'DESTINATION':
          name = '终点'
          break
        default:
          name = '途径'
          break
      }
      return name
    },
    // 添加途径点
    addRoutePoint () {
      if (this.model.others.length >= 14) {
        this.$message.error('途经点最多支持添加14个')
        return
      }
      this.model.others.push({
        id: _.uniqueId('temp_'),
        markName: '',
        selected: false,
        type: 'WAY_POINTS'
      })
      this.onChange()
    },
    // 删除途径点
    delRoutePoint (item) {
      const index = _.findIndex(this.model.others, item)
      this.model.others.splice(index, 1)
      this.onChange()
    },
    // 提供给外部使用
    setMarker (mark) {
      const { id, name: markName } = mark
      const fnToPosition = function ({ geometry, properties }) {
        let alt = 0
        try {
          alt = JSON.parse(properties.height_)[0]
        } catch {}
        return {
          lng: geometry.coordinates[0],
          lat: geometry.coordinates[1],
          alt: alt
        }
      }
      // 判断是否存在标记点重复设置
      const arr = this.others
      if (!arr.some((p) => p && p.selected)) {
        // 如果没有任何被选中
        return
      }
      if (_.some(arr, { id })) {
        this.$message.error('您已添加过该途经点')
      } else {
        _.chain(arr)
          .filter((p) => p && p.selected)
          .first()
          .merge({ id, markName, position: fnToPosition(mark.geoJson) })
          .value()
        this.onChange()
      }
    },
    focus (item) {
      this.others
        .filter((p) => p && p.selected && p !== item)
        .forEach((p) => (p.selected = false))
      item && (item.selected = true)
    },
    // 执行报错操作
    async save () {
      await this.$refs.form.validate()
      if (this.others.some((p) => !p.markName)) {
        this.$message.error('必须选择标记点')
        throw new Error('必须选择标记点')
      }
      const { id, way: pathType, name } = this.model
      let pathPlanning
      const marks = []
      this.others
        .map(({ id: markId, type, position }, sort) => ({
          markId,
          type,
          sort,
          position
        }))
        .forEach((p) => marks.push(p))
      // 选择的是无人机，直接生成规划路径
      if (/^DRONE$/.test(this.model.way)) {
        //
      } else {
        pathPlanning = await api.routePlanning({
          marks,
          pathType
        })
      }
      return {
        id,
        marks,
        name,
        pathType,
        pathPlanning
      }
    }
  },
  async mounted () {
    const { id, name, pathType: way } = this.info
    const marks = _.cloneDeep(this.info.marks || [])
    _.merge(this.model, {
      id,
      name,
      way
    })

    // 点类型， 起始点，目的地，途径点,可用值:ORIGIN,DESTINATION,WAY_POINTS
    if (marks.length >= 2) {
      // 获取起点
      const start = _.find(marks, { type: 'ORIGIN' })
      // 获取终点
      const end = _.find(marks, { type: 'DESTINATION' })
      const others = _.chain(marks)
        .filter((p) => p.type !== 'ORIGIN' && p.type !== 'DESTINATION')
        .value()
      _.merge(this.model.start, start, { id: start.markId })
      _.merge(this.model.end, end, { id: end.markId })
      this.model.others = others.map((p) => ({
        ...p,
        id: p.markId,
        type: 'WAY_POINTS',
        selected: false
      }))
    }
    await this.$nextTick()
  },
  filters: {}
}
</script>

<style lang="scss">
.RoutePointSet {
  .font-size-12 {
    font-size: 12px;
    .el-input {
      font-size: inherit;
    }
    .el-input__inner {
      font-size: inherit;
    }
  }
  .el-form {
    .el-form-item:last-child {
      margin-bottom: 0px;
    }
  }
  .el-form-item {
    user-select: none;
    margin-bottom: 16px;

    .el-form-item__label {
      line-height: 22px;
    }
    &.line-height-40 {
      color: #dddddd;
      .el-form-item__label {
        line-height: 40px;
      }
    }
  }
  .el-input.focus:not(:focus) .el-input__inner {
    // outline: 0;
    border-color: #00a4f0;
    box-shadow: 0 0 4px #0094d9;
  }

  .error-top-0 + .el-form-item__error {
    padding-top: 0px;
  }
}
</style>

<style lang="scss" scoped>
.cdddddd {
  color: #dddddd;
}
.c999999 {
  color: #999999;
}
.custom-icon {
  margin-right: 0px;
}
.RoutePointSet {
  text-align: left;
  display: flex;
  flex-direction: column;
  .el-form {
    .el-form-item:last-child,
    .el-form-item.no-margin-bottom {
      margin-bottom: 0px;
    }
    .el-form-item {
      margin-bottom: 8px;
    }
  }
}
.header {
  padding: 0px 8px 0px 12px;
  .block {
    position: relative;
    background-color: rgba(0, 164, 240, 1);
    width: 3px;
    height: 10px;
    border-radius: 2px;
  }
  .label {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
    margin-left: 8px;
  }
  .placeholder {
    width: calc(32px + 8px);
    height: 32px;
  }
}

.maxheight500 {
  max-height: 500px;
  overflow: auto;
}

.divider {
  width: 260px;
  height: 1px;
  margin: 12px 0px 0px 0px;
  border: 0px;
  background: rgba(255, 255, 255, 0.1);
  // border: 1px solid #424345;
}
// .el-select-dropdown .el-popper {
//   left: 0px !important;
// }
.label-div {
  margin: 12px 0px 8px 0px;
}
// .label {
//   margin: 12px 0px 8px 0px;
// }
</style>
